module.exports = __webpack_public_path__ + "static/media/sdg-goals.3373ed0f.png";